var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { ACTION_PRICING_GRID_COMPONENT as actionTypes, CONSTANTS } from '../utils/constants';
import { initialState } from './initialState';
import { calculateDays, setShippingConfigurationUser } from '../services/shippingutil';
export default function (state, action) {
  if (state === void 0) {
    state = initialState.pricingGrid;
  }

  switch (action.type) {
    case actionTypes.CLEAR_STATE:
      {
        return __assign({}, initialState.pricingGrid);
      }

    case actionTypes.LOAD_PRICING_GRID_DATA:
      {
        var _a = action.payload,
            skuData = _a.skuData,
            isSingleSkuEnvironment = _a.isSingleSkuEnvironment,
            parentService = _a.parentService,
            toolBarIconsProp = _a.toolBarIcons,
            showToolBarProp = _a.showToolBar,
            showCompetitivePricing = _a.showCompetitivePricing,
            competitors = _a.competitors,
            initialShippingConfiguration = _a.initialShippingConfiguration,
            productPriceContractsInfo = _a.productPriceContractsInfo,
            showTabbedView = _a.showTabbedView,
            selectedTab = _a.selectedTab,
            grossMarginSelections = _a.grossMarginSelections,
            saveTabInfo = _a.saveTabInfo;
        Object.entries(skuData).forEach(function (entry) {
          var _a = __read(entry, 2),
              sku = _a[0],
              resolvedAttributes = _a[1].resolvedAttributes;

          if (resolvedAttributes && resolvedAttributes.length) {
            resolvedAttributes.forEach(function (row) {
              row.values.forEach(function (item) {
                CONSTANTS.MCPSKU_CLASSES.forEach(function (className) {
                  item.attributes.push({
                    attributeKey: CONSTANTS.MCPSKU,
                    attributeValue: sku,
                    class: className
                  });
                });
              });
            });
          }
        });
        var sku = Object.keys(skuData)[0];
        var isPivoting = !!(isSingleSkuEnvironment && skuData[sku] && skuData[sku].selectedColumn);
        var showToolBar = showToolBarProp || true;
        var toolBarIcons = null;

        if (toolBarIconsProp) {
          toolBarIcons = toolBarIconsProp;
        } else {
          if (parentService === 'priceExplorer') {
            if (showCompetitivePricing) {
              toolBarIcons = {
                filter: true,
                settings: true,
                export: true,
                charts: true,
                shipping: false
              };
            } else {
              toolBarIcons = {
                filter: true,
                shipping: true,
                settings: true,
                export: true,
                charts: true
              };
            }
          }

          if (parentService === 'contracts') {
            toolBarIcons = {
              filter: true,
              shipping: false,
              settings: true,
              export: false,
              charts: true
            };
          }

          if (parentService === 'PIM') {
            toolBarIcons = {
              filter: true,
              shipping: true,
              settings: true,
              export: true,
              charts: true
            };
          }
        }

        return __assign(__assign(__assign({}, state), action.payload), {
          componentName: 'pricingGrid',
          initialized: true,
          isPivoting: isPivoting,
          showToolBar: showToolBar,
          parentService: parentService,
          toolBarIcons: toolBarIcons,
          showCompetitivePricing: showCompetitivePricing,
          competitors: competitors,
          initialShippingConfiguration: initialShippingConfiguration,
          productPriceContractsInfo: productPriceContractsInfo,
          showTabbedView: showTabbedView,
          selectedTab: selectedTab,
          grossMarginSelections: grossMarginSelections,
          saveTabInfo: saveTabInfo
        });
      }

    case actionTypes.ON_PRICE_MODE_CHANGE:
      {
        var priceMode = action.payload;
        return __assign(__assign({}, state), {
          priceMode: priceMode
        });
      }

    case actionTypes.SAVE_DELIVERY_LOCATIONS:
      {
        return __assign(__assign({}, state), {
          deliveryLocations: action.payload
        });
      }

    case actionTypes.SAVE_FULFILLMENT_LOCATIONS:
      {
        return __assign(__assign({}, state), {
          fulfillmentLocations: action.payload
        });
      }

    case actionTypes.SAVE_PRODUCTION_TIME:
      {
        var skuProductionTime = null;

        if (action.payload) {
          var response = action.payload.response;
          skuProductionTime = {
            actualProductionTime: response.Time,
            productionTime: calculateDays(response.Units, response.Time),
            productionTimeUnits: response.Units
          };
        }

        return __assign(__assign({}, state), {
          skuProductionTime: skuProductionTime
        });
      }

    case actionTypes.SAVE_SHIPPING_CONFIGURATION:
      {
        return __assign(__assign({}, state), {
          shippingConfiguration: action.payload
        });
      }

    case actionTypes.TOGGLE_SAVE_SHIPPING_CONFIG:
      {
        return __assign(__assign({}, state), {
          isSaveShippingEnabled: action.payload
        });
      }

    case actionTypes.SAVE_BUDGET_RATES:
      {
        return __assign(__assign({}, state), {
          budgetRates: action.payload
        });
      }

    case actionTypes.ON_SHIPPING_SUBMIT:
      {
        var _b = action.payload,
            destinationCountryCode = _b.destinationCountryCode,
            destinationPostalCode = _b.destinationPostalCode,
            shippingTime = _b.shippingTime,
            isSaveShippingEnabled = _b.isSaveShippingEnabled,
            city = _b.city,
            fulfillmentLocation = _b.fulfillmentLocation;
        var configuration = void 0;

        if (isSaveShippingEnabled) {
          configuration = {
            destinationCountryCode: destinationCountryCode,
            destinationPostalCode: destinationPostalCode,
            shippingTime: shippingTime,
            city: city
          };
          setShippingConfigurationUser(configuration);
        }

        return __assign(__assign({}, state), {
          shippingConfiguration: {
            destinationCountryCode: destinationCountryCode,
            destinationPostalCode: destinationPostalCode,
            shippingTime: shippingTime,
            city: city,
            fulfillmentLocation: fulfillmentLocation
          },
          isSaveShippingEnabled: isSaveShippingEnabled
        });
      }

    case actionTypes.SAVE_LOGGER:
      {
        return __assign(__assign({}, state), {
          logger: action.payload
        });
      }

    case actionTypes.SET_SELECTED_TAB:
      {
        return __assign(__assign({}, state), {
          selectedTab: action.payload
        });
      }

    default:
      return state;
  }
}